var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, observable, observe } from "mobx";
import { RetrieverFactory } from "./RetrieverFactory";
// TODO: refactor whole class, open techincal debt task!
export class Retriever {
    constructor(meta, dataProvider, deviceChangeDispatcherMock) {
        this.isLoading = false;
        this.leagues = observable([]);
        this.retrieverFactory = new RetrieverFactory(meta, dataProvider, this.loadLeagues, this.addLeagues, this.changeLeagues, this.deleteLeagues);
        this.deviceChangeDispatcherMock = deviceChangeDispatcherMock;
        this.loaderDisposer = () => { };
    }
    activate() {
        var _a;
        this.clearData();
        (_a = this.deviceChangeDispatcherMock) === null || _a === void 0 ? void 0 : _a.activate();
    }
    deactivate() {
        var _a, _b;
        this.clearData();
        this.loaderDisposer();
        (_a = this.deviceChangeDispatcherMock) === null || _a === void 0 ? void 0 : _a.deactivate();
        (_b = this.leaguesRetriever) === null || _b === void 0 ? void 0 : _b.deactivate();
    }
    selectRetriever(sportId, leagueIds) {
        var _a;
        this.isLoading = true;
        (_a = this.leaguesRetriever) === null || _a === void 0 ? void 0 : _a.deactivate();
        this.leaguesRetriever = this.retrieverFactory.createRetriever(sportId, leagueIds);
        this.loaderDisposer = observe(this.leaguesRetriever, "isLoading", this.updateLoader);
        this.leaguesRetriever.load();
    }
    setRegionId(regionId) {
        this.leaguesRetriever.setRegionIds && this.leaguesRetriever.setRegionIds(regionId);
    }
    removeRegionId() {
        this.leaguesRetriever.removeRegionId && this.leaguesRetriever.removeRegionId();
    }
    updateLoader(change) {
        this.isLoading = change.newValue;
    }
    loadLeagues(leagues) {
        this.isLoading = false;
        this.leagues.replace(leagues);
    }
    addLeagues(leagues) {
        this.leagues.push.apply(this.leagues, leagues);
    }
    changeLeagues(leagueChanges) {
        leagueChanges.forEach(leagueChange => {
            let leagueToUpdate = this.leagues.find(l => l.id === leagueChange.id);
            Object.keys(leagueChange).forEach(prop => {
                leagueToUpdate && (leagueToUpdate[prop] = leagueChange[prop]);
            });
        });
    }
    deleteLeagues(leaguesIds) {
        leaguesIds.forEach(id => {
            let index = this.leagues.findIndex(l => l.id === id);
            if (index >= 0) {
                this.leagues.splice(index, 1);
            }
        });
    }
    clearData() {
        this.leagues.clear();
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Retriever.prototype, "isLoading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "leagues", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "updateLoader", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "loadLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "addLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "changeLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "deleteLeagues", null);
//# sourceMappingURL=Retriever.js.map